<form [formGroup]="profileForm">
<input type="hidden" name="menuType" id="menuType" value="secure"/>
    

    <div class="ontario-row">
      <div class="ontario-columns ontario-small-12">

        <div *ngIf="(updated && appUpdateSuccess)" class="ontario-alert ontario-alert--success" aria-live="polite" aria-atomic="true" id="pageLevelMessageId" #pageMsg>
          <div class="ontario-alert__header">
            <div class="ontario-alert__header-icon">
              <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet"><use href="#ontario-icon-alert-success"></use></svg>
            </div>
            <h2 class="ontario-alert__header-title ontario-h4"> {{'bss.profile.success' | translate }}:</h2>
          </div>
          <div class="ontario-alert__body">
            <p [innerHTML]="appSuccessMessage | translate"></p>
          </div>
        </div>
      </div>
    </div>

    <div class="ontario-row">
      <div class="ontario-column ontario-small-12">  
        <div *ngIf="(submitted || onLoad) && appError" class="ontario-alert ontario-alert--error" aria-live="polite" aria-atomic="true" id="pageLevelMessageId" #pageMsg>
          <div class="ontario-alert__header">
            <div class="ontario-alert__header-icon">
                <svg class="ontario-icon" alt="Error" aria-hidden="true" focusable="false"
                    sol:category="primary" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                    <use href="#ontario-icon-alert-error"></use>
                </svg>
            </div>
            <h2 class="ontario-alert__header-title ontario-h4">{{'bss.profile.error' | translate }}</h2>
          </div>
          <div class="ontario-alert__body">
              <p [innerHTML]="appErrorMessage | translate"></p>
          </div>
        </div>
      </div>
    </div>

    <div class="ontario-row">
      <div class="ontario-columns">
        <h2 id="pageTitle">{{'bss.profile.title' | translate }} </h2>
        <hr>
        <dl><dt class="fractal-dt ontario-padding-bottom-24-!">
          {{'bss.profile.subtitle' | translate }}
        </dt><dd></dd></dl>
      </div>
    </div>
  
    <div class="ontario-row">
      <dl><dt></dt><dd>
        <div class="ontario-columns ontario-small-12 ontario-medium-3">
          <label class="ontario-label" for="firstname">
            {{'bss.profile.label.firstname' | translate }} <span class="ontario-label__flag"></span>
            <span class="ontario-label__flag">
              ({{'bss.register.required' | translate }})
            </span>
          </label>
        </div>

        <input type="hidden" name="pkiuser" id="pkiuser" [value]="user.pkiuser ? user.pkiuser : '' "/>
        <input type="hidden" name="isCertificatelogin" id="isCertificatelogin" value="{{isCertificatelogin}}"/>

            <div class="ontario-columns ontario-small-12 ontario-medium-9">
              <input tabindex="101" class="ontario-input ontario-input--20-char-width" type="text" 
                id="firstname" [readonly]="isCertificatelogin"
                [value]="user.firstName ? user.firstName : '' " title=" {{'bss.register.firstName.title' | translate }}" formControlName="firstName" aria-describedby="firstNameError" #firstNameInput
                (input)="updateDisplayName(firstNameInput.value, middleNameInput.value, lastNameInput.value)">
            
                <div *ngIf="(submitted || profileForm.get('firstName').touched || profileForm.get('firstName').dirty) && (profileForm.get('firstName').errors?.['required'])" id="firstNameError" role="alert" aria-live="assertive" class="ontario-alert ontario-alert--error">          
                  <ul>
                      <li>{{'bss.register.error.firstName.required' | translate }} </li>
                  </ul>
                </div>
                 
                <div *ngIf="(submitted || profileForm.get('firstName').touched || profileForm.get('firstName').dirty) &&  (profileForm.get('firstName').errors?.['pattern'])" id="firstNameError" role="alert" aria-live="assertive"  class="ontario-alert ontario-alert--error">             
                  <ul>
                      <li>{{'bss.register.error.firstName.invalid' | translate }}</li>
                  </ul>               
                </div>  
            </div>

      </dd></dl>
    </div>

    <div class="ontario-row">
      <dl><dt></dt><dd>
        <div class="ontario-columns ontario-small-12 ontario-medium-3">
          <label class="ontario-label" for="middlename">
            {{'bss.profile.label.middlename' | translate }}
            <span class="ontario-label__flag"> ({{'bss.register.optional' |
              translate }}) </span>
          </label>
        </div>
          
          <div class="ontario-columns ontario-small-12 ontario-medium-9">
            <input tabindex="102" class="ontario-input ontario-input--20-char-width" type="text" 
              id="middlename" [readonly]="isCertificatelogin" 
              title="{{'bss.register.middleName.title' | translate }}" [value]="user.middleName ? user.middleName : '' " formControlName="middleName" #middleNameInput
              (input)="updateDisplayName(firstNameInput.value, middleNameInput.value, lastNameInput.value)">
              
              <div
              *ngIf="(submitted || profileForm.get('middleName').touched || profileForm.get('middleName').dirty) && (profileForm.get('middleName').errors?.['pattern'])"
              id="middleNameError" role="alert" aria-live="assertive" class="ontario-alert ontario-alert--error">
                <ul>
                  <li>{{'bss.register.error.middleName.invalid' | translate }} </li>
                </ul>
              </div>          
            </div>        
      </dd></dl>
    </div>

    <div class="ontario-row">
      <dl><dt></dt><dd>
        <div class="ontario-columns ontario-small-12 ontario-medium-3">
          <label class="ontario-label" for="lastname">
            {{'bss.profile.label.lastname' | translate }}
            <span class="ontario-label__flag">
              ({{'bss.register.required' | translate }})
            </span>
          </label>
        </div>
        <div class="ontario-columns ontario-small-12 ontario-medium-9">
            <input tabindex="103" class="ontario-input ontario-input--20-char-width" type="text" 
              id="lastname" [readonly]="isCertificatelogin"
              title="{{'bss.register.lastName.title' | translate }}" [value]="user.lastName ? user.lastName : '' " formControlName="lastName" aria-describedby="lastNameError" #lastNameInput
              (input)="updateDisplayName(firstNameInput.value, middleNameInput.value, lastNameInput.value)">
          
            <div *ngIf="(submitted || profileForm.get('lastName').touched || profileForm.get('lastName').dirty) && (profileForm.get('lastName').errors?.['required'])" id="lastNameError" role="alert" aria-live="assertive"  class="ontario-alert ontario-alert--error">
              <ul>
                  <li>{{'bss.register.error.lastName.required' | translate }} </li>
              </ul>
            </div>

            <div *ngIf="(submitted || profileForm.get('lastName').touched || profileForm.get('lastName').dirty) &&  (profileForm.get('lastName').errors?.['pattern'])" id="lastNameError" role="alert" aria-live="assertive" class="ontario-alert ontario-alert--error">
              <ul>
                  <li>{{'bss.register.error.lastName.invalid' | translate }}  </li>
              </ul>
            </div>
          </div>
      </dd></dl>
    </div>

    <div class="ontario-row">
      <dl><dt></dt><dd>
        <div class="ontario-columns ontario-small-12 ontario-medium-3">
          <label class="ontario-label" for="displayname">
            {{'bss.profile.label.displayname' | translate }}
            <span class="ontario-label__flag">
              ({{'bss.register.required' | translate }})
            </span>
          </label>
        </div>

        <div class="ontario-columns ontario-small-12 ontario-medium-9">
            <input tabindex="104" class="ontario-input ontario-input--20-char-width" type="text" 
              id="displayname" [readonly]="isCertificatelogin" 
              title="{{'bss.register.displayName.title' | translate }}" [value]="user.displayName ? user.displayName : '' " formControlName="displayName" aria-describedby="displayNameError">
         
            <div *ngIf="(submitted || profileForm.get('displayName').touched || profileForm.get('displayName').dirty) &&  (profileForm.get('displayName').errors?.['required'])" id="displayNameError" role="alert" aria-live="assertive" class="ontario-alert ontario-alert--error">
              <ul>
                  <li>{{'bss.register.error.displayName.required' | translate }} </li>
              </ul>
            </div>
            
            <div *ngIf="(submitted || profileForm.get('displayName').touched || profileForm.get('displayName').dirty || (profileForm.get('firstName').touched && profileForm.get('lastName').touched) ) &&  (profileForm.get('displayName').errors?.['pattern'])" id="displayNameError" role="alert" aria-live="assertive" class="ontario-alert ontario-alert--error">             
              <ul>
                  <li>{{'bss.register.error.displayName.invalid' | translate }} </li>
              </ul>               
            </div> 
          </div>
      </dd></dl>
    </div>

    <div class="ontario-row">
      <dl><dt></dt><dd>
        <div class="ontario-columns ontario-small-12 ontario-medium-3">            
            <label class="ontario-label" for="prefLanguage">
            {{'bss.profile.label.preferredLanguage' | translate }}
            <span class="ontario-label__flag">
              ({{'bss.register.required' | translate }})
            </span>
            </label>
        </div>
        
        <div class="ontario-columns ontario-small-12 ontario-medium-9">  
          <div class="ontario-radios" layout="row"> 
            <div class="ontario-radios__item">
              <input aria-describedby="preFerredLanguageError" tabindex="105" class="ontario-radios__input" type="radio" id="prefLangEn" title="{{ 'bss.profile.prefLanguage.title.English' | translate }}" name="preferredLanguage" value="en" [checked]="selectedOption === 'en'" formControlName="preferredLanguage">
              <label class="ontario-label ontario-radios__label" for="prefLangEn"> {{'bss.profile.preferredLanguage.option.English' | translate }}</label>
            </div>
                 
            <div class="ontario-radios__item"> 
                <input aria-describedby="preFerredLanguageError" tabindex="106" class="ontario-radios__input" type="radio" id="prefLangFr" title="{{ 'bss.profile.prefLanguage.title.French' | translate }}" name="preferredLanguage" value="fr" [checked]="selectedOption === 'fr'" formControlName="preferredLanguage">
                <label class="ontario-label ontario-radios__label" for="prefLangFr"> {{'bss.profile.preferredLanguage.option.French' | translate }}</label>
            </div>  
          </div>            

            <div *ngIf="submitted && (profileForm.get('preferredLanguage').errors?.['required'])" id="preFerredLanguageError" role="alert" aria-live="assertive" class="ontario-alert ontario-alert--error">
              <ul>
                  <li>{{'bss.profile.prefLanguage.error.required' | translate }} </li>
              </ul>
            </div>
        </div> 
      </dd></dl>               
    </div>


    <div class="ontario-row">
      <dl><dt></dt><dd>
        <div class="ontario-columns ontario-small-12 ontario-medium-3">
        </div>
        <div class="ontario-columns ontario-small-12 ontario-medium-9">
          <button tabindex="107" class="ontario-button" [ngClass]="{'ontario-button--primary': !isSubmitting}"
           title="{{ isCertificatelogin ? ('bss.profile.button.updateLang.title' | translate) : ('bss.profile.button.updateInfo.title' | translate) }}" (click)="updateInfo()" [disabled]="isSubmitting" 
           aria-describedby="pageLevelMessageId">
            {{ isCertificatelogin ? ('bss.profile.button.updateLang' | translate) :  ('bss.profile.button.updateInfo' | translate)}} 
          </button>     
        </div>
      </dd></dl>
    </div>

    <div class="ontario-row">
      <dl><dt></dt><dd>
        <div class="ontario-columns ontario-small-12 ontario-medium-3">
          <label class="ontario-label">
            {{'bss.profile.label.email' | translate }}<span class="ontario-label__flag"></span>
          </label>
        </div>
        <div *ngIf="user.email" class="ontario-columns ontario-small-12 ontario-medium-9">
           {{user.email}}
        </div>
      </dd></dl>
    </div>


    <div class="ontario-row" *ngIf="!isCertificatelogin">
      <dl><dt></dt><dd>
        <div class="ontario-columns ontario-small-12 ontario-medium-3">
        </div>
        <div class="ontario-columns ontario-small-12 ontario-medium-9">
          <button tabindex="108" class="ontario-button ontario-button--primary" title="{{'bss.profile.button.updateEmail.title' | translate }} " (click)="updateEmail()">
            {{'bss.profile.button.updateEmail' | translate }} 
          </button>     
        </div>
      </dd></dl>
    </div>

    <div class="ontario-row" *ngIf="!isCertificatelogin">
      <dl><dt></dt><dd>
        <div class="ontario-columns ontario-small-12 ontario-medium-3">
          <label class="ontario-label">
             {{'bss.profile.label.password' | translate }} <span class="ontario-label__flag"></span>
          </label>
        </div>
        <div class="ontario-columns ontario-small-12 ontario-medium-9">
          <button tabindex="109" class="ontario-button ontario-button--primary" title="{{'bss.profile.button.changePassword.title' | translate }}" (click)="changePassword()">
             {{'bss.profile.button.changePassword' | translate }} 
          </button>     
        </div>
      </dd></dl>
    </div>

    <div class="ontario-row">
      <dl><dt></dt><dd>
        <div class="ontario-columns ontario-small-12 ontario-medium-3">
          <label class="ontario-label">
            {{'bss.profile.label.roles' | translate }} <span class="ontario-label__flag"></span>
          </label>
        </div>
        <div class="ontario-columns ontario-small-12 ontario-medium-9">
          <button tabindex="110" class="ontario-button ontario-button--primary" title="{{'bss.profile.button.viewRoles.title' | translate }}" (click)="viewRoles()">
           {{'bss.profile.button.viewRoles' | translate }} 
          </button>     
        </div>
      </dd></dl>
    </div>
    
    <div class="ontario-row" *ngIf="backUrlExists">
      <dl><dt></dt><dd>
        <!--
        <div class="ontario-columns ontario-small-12 ontario-medium-3">
        </div>
        -->
        <div class="ontario-columns ontario-small-12 ontario-medium-12">
            <br/> <p>  <a class="link" tabindex="111" (click)="previousSite()"
            title="{{'bss.profile.returnToPrevSite.title' | translate }}"> {{'bss.profile.returnToPrevSite.link' |
            translate }} </a></p>
        </div>
      </dd></dl>
    </div>
</form>

<dialog class="ontario-progress" #progressDialog>
  <app-progress></app-progress>
</dialog>